import { createLocalStorageStateHook } from "use-local-storage-state";

export default createLocalStorageStateHook<false | string>("dfi-sidenav-open-item", false);
